import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
@Component({
  selector: 'app-paid-fees-modal',
  templateUrl: './paid-fees-modal.component.html',
  styleUrls: ['./paid-fees-modal.component.css']
})
export class PaidFeesModalComponent implements OnInit {
  semester: string;
  department: string;
  season: string;
  year: string;
  fees: string;
  feeAmount: string;
  totalPaid: number = 0;
  totalUnpaid: number = 0;
  constructor(public dialogRef: MatDialogRef<PaidFeesModalComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.semester = data.semester;
    this.department = data.department;
    this.season = data.season;
    this.year = data.year;
    this.fees = data.fees;
    this.feeAmount = data.feeAmount;
  }

  ngOnInit() {
    console.log(this.fees);
    for (let a of this.fees) {
      if (a["clear_status"] == 'Y') {
        console.log(a["clear_status"] + "Paid");
        a["clear_status"] = 'پرداخت شده';
        this.totalPaid += Number(a["payable_amount"]);
      } else {
        a["clear_status"] = 'پرداخت نشده';
        console.log(a["clear_status"] + "Paid");
        this.totalUnpaid += Number(a["payable_amount"]);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/TRNs/student-invoice/paid-fees-modal/paid-fees-modal.component.ts